export default "__VITE_ASSET__Duq2705L__"